export default __webpack_public_path__ + "static/media/Classwin logo_Classwin Horizontal - Blue.f6dfdd22.png";